import { Box } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import SvgToIcon from "../../icons/SvgToIcon";
import { icons } from "../stack/environment/icons/iconExport";

const PinIcon = ({ isPinned, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);
  const boxRef = useRef(null);

  // Preventing the "stuck" hover state - the hover state will be reset whenever the mouse is detected outside the Box element
  useEffect(() => {
    const handleMouseMove = (event) => {
      if (boxRef.current) {
        const rect = boxRef.current.getBoundingClientRect();
        const isInside =
          event.clientX >= rect.left &&
          event.clientX <= rect.right &&
          event.clientY >= rect.top &&
          event.clientY <= rect.bottom;

        if (!isInside && isHovered) {
          setIsHovered(false);
        }
      }
    };

    document.addEventListener("mousemove", handleMouseMove);
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, [isHovered]);

  return (
    <Box
      ref={boxRef}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        cursor: "pointer",
        "&:hover": {
          opacity: 0.8,
        },
      }}
    >
      <SvgToIcon
        IconLogo={
          isPinned || isHovered ? icons.pinSelectedIcon : icons.pinDefaultIcon
        }
        width="14px"
        style={{
          fill: "none",
        }}
      />
    </Box>
  );
};

export default PinIcon;
